"use strict";
/* istanbul ignore file */

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Inspired by fast-memoize
 * @see https://www.npmjs.com/package/fast-memoize
 */
//
// Cache
//

function ObjectWithoutPrototypeCache() {
  this.cache = Object.create(null);
}

ObjectWithoutPrototypeCache.prototype.has = function (key) {
  return key in this.cache;
};

ObjectWithoutPrototypeCache.prototype.get = function (key) {
  return this.cache[key];
};

ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
  this.cache[key] = value;
};

var cacheDefault = {
  create: function create() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return new ObjectWithoutPrototypeCache();
  }
}; //
// Strategy
//

function isPrimitive(value) {
  // typeof value === "string" - 'unsafe' primitive for our needs
  return value == null || typeof value === 'number' || typeof value === 'boolean';
} // tslint:disable-next-line:ban-types


function monadic(fn, cache, serializer, arg) {
  var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
  var computedValue = cache.get(cacheKey);

  if (typeof computedValue === 'undefined') {
    computedValue = fn.call(this, arg);
    cache.set(cacheKey, computedValue);
  }

  return computedValue;
} // tslint:disable-next-line:ban-types


function variadic(fn, cache, serializer) {
  // eslint-disable-next-line prefer-rest-params
  var args = Array.prototype.slice.call(arguments, 3);
  var cacheKey = serializer(args);
  var computedValue = cache.get(cacheKey);

  if (typeof computedValue === 'undefined') {
    computedValue = fn.apply(this, args);
    cache.set(cacheKey, computedValue);
  }

  return computedValue;
} // tslint:disable-next-line:ban-types


function assemble(fn, context, strategy, cache, serialize) {
  return strategy.bind(context, fn, cache, serialize);
} // tslint:disable-next-line:ban-types


function strategyDefault(fn, options) {
  var strategy = fn.length === 1 ? monadic : variadic;
  return assemble(fn, options.context || this, strategy, options.cache.create(), options.serializer);
} //
// Serializer
//


function serializerDefault() {
  // eslint-disable-next-line prefer-rest-params
  return JSON.stringify(arguments);
} //
// Export
//


function memoize(fn, context) {
  return strategyDefault(fn, {
    cache: cacheDefault,
    serializer: serializerDefault,
    context: context
  });
}

exports.default = memoize;